import React, {useEffect} from 'react';
import styled from 'styled-components';
import {fontSize, tabletWidth} from '../../mixins';
import {useSelector} from 'react-redux';
import {selectEventsData, selectPseudoInviteLink} from '../onboarding/onboardingSlice';
import {sendAnalyticsEvents} from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import QRCodeComp from '../../UI/QRCodeComp';


const StyledWrapper = styled.div`
  padding-top: 20px;
  width: 340px;
  
  @media screen and (max-width: ${tabletWidth}) {
      width: 290px;
  }
  
  @media screen and (device-width: 320px) {
      width: 220px;
  }
`

const StyledText = styled.p`
  ${fontSize(14)};
  line-height: 20px;
  color: #323232;
  mix-blend-mode: normal;
  opacity: .8;
`



const QRInvite = () => {
    const inviteLink = useSelector(selectPseudoInviteLink);
    const amplitudeEventData = useSelector(selectEventsData);


    useEffect(() => sendAnalyticsEvents(EVENTS.QRCode, amplitudeEventData), []);

    return (
        <StyledWrapper>
            <StyledText>Still waiting for the phone to be connected.</StyledText>
            <StyledText>Scan the QR Code with your loved one’s phone to locate them instantly.</StyledText>
            <QRCodeComp link={inviteLink} size={200}/>
            <StyledText>Or open the link on their phone.</StyledText>
        </StyledWrapper>
    )
};

export default QRInvite;